import { cn } from "@/lib/utils";
import { Eyebrow, Reveal } from "../reveal";

const options = [
  { id: "pull-through", label: "Pull Through" },
  { id: "back-in", label: "Back In" },
  { id: "accessible", label: "Accessible" },
];

function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function SiteTypeNav() {
  return (
    <section
      id="site-types"
      aria-labelledby="site-type-nav-heading"
      className="border-y border-border bg-secondary/40 py-10 md:py-10"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Find Your Fit</Eyebrow>
          <h2 id="site-type-nav-heading" className="display-md mt-4">
            Choose Your Site Type
          </h2>
        </Reveal>

        <Reveal delay={0.08}>
          <div
            role="navigation"
            aria-label="Site type sections"
            className="mt-8 flex snap-x gap-3 overflow-x-auto pb-2 [scrollbar-width:none] md:grid md:grid-cols-3 md:gap-4 md:overflow-visible md:pb-0"
          >
            {options.map((option) => (
              <button
                key={option.id}
                type="button"
                onClick={() => scrollToSection(option.id)}
                className={cn(
                  "eyebrow min-w-[70%] snap-start border border-border bg-background px-6 py-6 text-left transition-all duration-300",
                  "hover:-translate-y-0.5 hover:border-primary hover:shadow-soft sm:min-w-[45%] md:min-w-0 md:px-8 md:py-8",
                )}
              >
                <span className="block text-foreground">{option.label}</span>
                <span className="mt-2 block text-[0.62rem] tracking-[0.18em] text-muted-foreground normal-case">
                  Jump to details
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
